var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdSaveChkboxOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Property 1=on"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6 0H6.4C2.86538 0 0 2.86538 0 6.4V25.6C0 29.1346 2.86538 32 6.4 32H25.6C29.1346 32 32 29.1346 32 25.6V6.4C32 2.86538 29.1346 0 25.6 0ZM23.3472 11.9368C23.7541 11.4136 23.6599 10.6597 23.1367 10.2528C22.6136 9.84595 21.8597 9.94019 21.4528 10.4633L15.0416 18.7063C14.899 18.8896 14.6309 18.9134 14.4583 18.758L10.4028 15.1081C9.91016 14.6648 9.15141 14.7047 8.70806 15.1973C8.26471 15.6899 8.30464 16.4487 8.79725 16.892L12.8527 20.542C14.061 21.6293 15.9381 21.4628 16.936 20.1798L23.3472 11.9368Z",
    fill: "#2962FA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdSaveChkboxOn);
export default __webpack_public_path__ + "static/media/idSaveChkbox-on.c5efdc3b3931fc0f99e1d07d1c00e618.svg";
export { ForwardRef as ReactComponent };